/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderQueryResult from './OrderQueryResult';

/**
 * The OrderOutputCmsOrders model module.
 * @module model/OrderOutputCmsOrders
 * @version 1.0
 */
class OrderOutputCmsOrders {
    /**
     * Constructs a new <code>OrderOutputCmsOrders</code>.
     * @alias module:model/OrderOutputCmsOrders
     */
    constructor() { 
        
        OrderOutputCmsOrders.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderOutputCmsOrders</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderOutputCmsOrders} obj Optional instance to populate.
     * @return {module:model/OrderOutputCmsOrders} The populated <code>OrderOutputCmsOrders</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderOutputCmsOrders();

            if (data.hasOwnProperty('orders')) {
                obj['orders'] = ApiClient.convertToType(data['orders'], [OrderQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/OrderQueryResult>} orders
 */
OrderOutputCmsOrders.prototype['orders'] = undefined;






export default OrderOutputCmsOrders;

